export const fetchSubsidizedStudentsTypes = [
  'FETCH_SUBSIDIZED_STUDENTS',
  'FETCH_SUBSIDIZED_STUDENTS_SUCCESS',
  'FETCH_SUBSIDIZED_STUDENTS_FAIL',
];

export const approveStudentSubsidyTypes = [
  'APPROVE_STUDENT_SUBSIDY',
  'APPROVE_STUDENT_SUBSIDY_SUCCESS',
  'APPROVE_STUDENT_SUBSIDY_FAIL',
];

export const rejectStudentSubsidyTypes = [
  'REJECT_STUDENT_SUBSIDY',
  'REJECT_STUDENT_SUBSIDY_SUCCESS',
  'REJECT_STUDENT_SUBSIDY_FAIL',
];

export const addSubsidyCreditsTypes = [
  'ADD_SUBSIDY_CREDITS',
  'ADD_SUBSIDY_CREDITS_SUCCESS',
  'ADD_SUBSIDY_CREDITS_FAIL',
];

export const addSubsidyStudentsTypes = [
  'ADD_SUBSIDY_STUDENTS',
  'ADD_SUBSIDY_STUDENTS_SUCCESS',
  'ADD_SUBSIDY_STUDENTS_FAIL',
];

export const removeSubsidyStudentsTypes = [
  'REMOVE_SUBSIDY_STUDENTS',
  'REMOVE_SUBSIDY_STUDENTS_SUCCESS',
  'REMOVE_SUBSIDY_STUDENTS_FAIL',
];

export const distributeSubsidyCreditsTypes = [
  'DISTRIBUTE_SUBSIDY_CREDITS',
  'DISTRIBUTE_SUBSIDY_CREDITS_SUCCESS',
  'DISTRIBUTE_SUBSIDY_CREDITS_FAIL',
];

export const fetchStudentSubsidyTransactionsTypes = [
  'FETCH_STUDENT_SUBSIDY_TRANSACTIONS',
  'FETCH_STUDENT_SUBSIDY_TRANSACTIONS_SUCCESS',
  'FETCH_STUDENT_SUBSIDY_TRANSACTIONS_FAIL',
];

export const createSubsidyTypes = [
  'CREATE_SUBSIDY',
  'CREATE_SUBSIDY_SUCCESS',
  'CREATE_SUBSIDY_FAIL',
];

export const editSubsidyTypes = [
  'EDIT_SUBSIDY',
  'EDIT_SUBSIDY_SUCCESS',
  'EDIT_SUBSIDY_FAIL',
];

export const studentSubsidyApproveTypes = [
  'STUDENT_SUBSIDY_APPROVE',
  'STUDENT_SUBSIDY_APPROVE_SUCCESS',
  'STUDENT_SUBSIDY_APPROVE_FAIL',
];

export const studentSubsidyRejectTypes = [
  'STUDENT_SUBSIDY_REJECT',
  'STUDENT_SUBSIDY_REJECT_SUCCESS',
  'STUDENT_SUBSIDY_REJECT_FAIL',
];

export const adminAddCardTypes = [
  'ADMIN_ADD_CARD',
  'ADMIN_ADD_CARD_SUCCESS',
  'ADMIN_ADD_CARD_FAIL',
];

export const subsidyCreditsPurchaseTypes = [
  'SUBSIDY_CREDITS_PURCHASE',
  'SUBSIDY_CREDITS_PURCHASE_SUCCESS',
  'SUBSIDY_CREDITS_PURCHASE_FAIL'
];

export const adminChangeDefaultCardTypes = [
  'ADMIN_CHANGE_DEFAULT_CARD',
  'ADMIN_CHANGE_DEFAULT_CARD_SUCCESS',
  'ADMIN_CHANGE_DEFAULT_CARD_FAIL'
];

export const CLEAR_PAYMENT_STATUS = 'CLEAR_PAYMENT_STATUS';
export const SUBSCRIBE_TO_SUBSIDY = 'SUBSCRIBE_TO_SUBSIDY';



// WEBPACK FOOTER //
// ./src/modules/subsidy/action_types.js